<template>
    <div id="laudoForm" v-if="value && atendimento_procedimento">
        <!-- Laudo em Partes -->
        <div class="mt-3" v-if="is_laudo_partes">

            <div v-for="(lista_partes, grupo, igrx) in titulo_agrupado(value.partes)" :key="igrx">
                <div class="alert alert-info">
                    <a class="card-link" data-toggle="collapse" :href="'#grupoParte' + igrx">
                        {{ ( grupo && grupo !== 'null' ) ? grupo : 'Sem Título' }}
                    </a>
                </div>

                <div v-for="(registro, iregx) in lista_partes" :key="iregx" class="collapse show" :id="'grupoParte' + igrx">
                    <div v-if="registro.fl_ativo && registro.st_conteudo && registro.st_conteudo.length" :class="'parte' + registro.id_laudo_item + ' ' + ( registro.edicao ? 'em_edicao' : '' )">
                        <az-sub-title :title="titulo_registro(registro)" :showhide="true" :model="registro">

                            <template v-if="!registro.hide">

                                <template v-if="registro.id_laudo_item">
                                    <span class="small text-muted mr-2" title="id">{{ registro.id_laudo_item }}</span>
                                    <az-audit-log-button model="laudoItem" :id="registro.id_laudo_item" sizing="sm" />
                                    <button type="button" class="btn btn-outline-secondary btn-sm ml-1" @click="imprimir_registro(registro)" v-if="false">
                                        <i class="fa fa-print" aria-hidden="true"></i>
                                    </button>    
                                </template>

                                <!-- Não Pode Editar -->
                                <template v-if="registro.pode_editar === false || !pode_editar_laudo()">
                                    <span v-if="registro.doc_certificado && registro.doc_certificado_link">
                                        <a :href="registro.doc_certificado_link" class="btn btn-outline-primary btn-sm ml-1" target="_blank">
                                            <i class="fas fa-file-contract"></i>
                                        </a>
                                    </span>
                                    <span v-else-if="registro.doc_certificado">
                                        <button type="button" class="btn btn-outline-primary btn-sm ml-1" disabled>
                                            <i class="fas fa-file-contract ml-1"></i>
                                        </button>
                                    </span>
                                </template>

                                <!-- Pode Editar -->
                                <template v-else>

                                    <button type="button" class="btn btn-outline-primary btn-sm ml-1" @click="incluir_mesclado(registro)" v-if="registro.edicao && !registro.doc_certificado" 
                                        data-toggle="tooltip" data-placement="top" title="Incluir Parte Unificada (CONTROL+D)" v-shortkey="['ctrl', 'd']" @shortkey="incluir_mesclado(registro)">
                                        <i class="fa-solid fa-square-plus"></i>
                                    </button>

                                    <button type="button" class="btn btn-outline-danger btn-sm ml-1" @click="remover_parte(registro, iregx)" v-if="!registro.doc_certificado">
                                        <i class="fa fa-minus" aria-hidden="true"></i>
                                    </button>

                                    <template v-if="registro.edicao">
                                        <az-submit :color="( !saved ? 'outline-secondary' : 'outline-success' ) + ' btn-sm ml-1'" @click="salvar_parte(registro)" v-if="registro.edicao" :hide_content_while_loading="true">
                                            <i class="fa fa-check fa-fw" aria-hidden="true" v-if="!$store.state.loading"></i>
                                        </az-submit>
                                    </template>

                                    <template v-else>
                                        <span v-if="registro.doc_certificado && registro.doc_certificado_link && registro.id_usuario == $store.state.user.id_usuario">
                                            <a href="#" class="btn btn-outline-danger btn-sm ml-1" @click.prevent="remover_parte(registro, iregx)" title="Cancelar documento.">
                                                <i class="fa fa-times-circle" aria-hidden="true"></i>
                                            </a>
                                        </span>
                                        <span v-if="registro.doc_certificado && registro.doc_certificado_link">
                                            <a :href="registro.doc_certificado_link" class="btn btn-outline-primary btn-sm ml-1" target="_blank">
                                                <i class="fas fa-file-contract"></i>
                                            </a>
                                        </span>
                                        <span v-else-if="registro.doc_certificado">
                                            <button type="button" class="btn btn-outline-primary btn-sm ml-1" disabled>
                                                <i class="fas fa-file-contract ml-1"></i>
                                            </button>
                                        </span>

                                        <template v-else>
                                            <button type="button" class="btn btn-outline-success btn-sm ml-1" @click="editar_parte(registro)" title="Editar">
                                                <i class="fas fa-edit"></i>
                                            </button>
                                        </template>
                                    </template>

                                </template>

                            </template>

                        </az-sub-title>

                        <div class="d-flex flex-column" v-if="registro.edicao && registro.anterior && registro.anterior.st_conteudo">
                            <button type="button" class="btn btn-sm btn-outline-primary" @click="herdar_anterior(registro)">
                                Herdar Registro Anterior 
                                <i class="fas fa-history mx-3"></i>
                                {{ $util.getFormatDate(registro.anterior.data_ref ? registro.anterior.data_ref : registro.anterior.created_at) }}
                            </button>
                        </div>

                        <div class="alert alert-warning" v-if="registro.novo && !registro.id_laudo_item">
                            Novo. Aguardando Gravação.
                        </div>

                        <div class="alert alert-warning" v-else-if="!registro.edicao && registro.fl_edicao">
                            Registro em Edição.  
                        </div>

                        <template v-if="!registro.hide">

                            <!-- :validate="validate" -->

                            <campos-formulario 
                                :ref="registro.edicao ? 'formedit' : 'formedit' + iregx"
                                :show_boxes="show_boxes"
                                v-model="registro.st_conteudo" 
                                :textos="textos"
                                :saved="saved"
                                :raiz="true" 
                                :mode="registro.edicao ? 'edit' : 'view'"
                                :compact="registro.modelo.fl_compact"
                                :modelo="registro.modelo" />

                            <az-sub-title :title="'Fim: ' + titulo_registro(registro)" class="mt-3" v-if="registro.edicao">
                                <button type="button" class="btn btn-outline-danger btn-sm ml-1" @click="remover_registro(registro)">
                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                </button>

                                <az-submit color="outline-success btn-sm ml-1" @click="salvar_parte(registro)" v-if="registro.edicao" :hide_content_while_loading="true">
                                    <i class="fa fa-check fa-fw" aria-hidden="true" v-if="!$store.state.loading"></i>
                                </az-submit>

                                <button type="button" class="btn btn-outline-success btn-sm ml-1" @click="editar_parte(registro)"         
                                    v-else>
                                    <i class="fas fa-edit"></i>
                                </button>
                            </az-sub-title>

                        </template> 
                    </div>
                </div>
            </div>

            <hr>

            <div class="d-flex justify-content-between">
                <div>
                    <template v-if="pode_editar_laudo() && !parte_em_edicao">
                        <button type="button" class="btn btn-outline-primary btn-sm" @click="incluir_parte()" data-toggle="tooltip" data-placement="top" title="Incluir Parte (CONTROL+D)" v-shortkey="['ctrl', 'd']" @shortkey="incluir_parte()">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </button>
                    </template>

                    <button type="button" class="btn btn-sm btn-outline-primary ml-1" v-if="value.partes && value.partes.length" @click="imprimir(value.id_laudo)" title="Imprimir">
                        <i class="fa fa-print" aria-hidden="true"></i>
                    </button>

                    <button type="button" class="btn btn-sm btn-outline-secondary ml-1" v-if="value.partes && value.partes.length > 1" @click="toggle_compress()" title="Ordenar">
                        <i class="fa-solid fa-minimize"></i>
                    </button>

                    <button type="button" class="btn btn-sm btn-outline-secondary ml-1" v-if="value.partes && value.partes.length > 1" @click="show_boxes = !show_boxes" title="Exibir/Ocultar Detalhes">
                        <i class="fa-solid fa-subtitles" v-if="show_boxes"></i>
                        <i class="fa-solid fa-subtitles-slash" v-else></i>
                    </button>

                    <button type="button" class="btn btn-sm btn-outline-secondary ml-1" v-if="value.partes && value.partes.length > 1" @click="ordenar_partes()" title="Ordenar">
                        <i class="fa-solid fa-sort"></i>
                    </button>
                </div>
                <div class="text-right">
                    #{{ atendimento_procedimento.id_atendimento }}
                    <div v-if="outros_laudos && outros_laudos.length">
                        <span v-for="(atp_item, aix) in outros_laudos" :key="aix" class="badge ml-1" :class="'badge-' + ( atp_item.laudo && atp_item.laudo.status_laudo ? atp_item.laudo.status_laudo.st_color : 'primary' )">
                            {{ atp_item.procedimento.st_sigla }}
                        </span>
                    </div>
                </div>
            </div>

            <laudo-item-modelo 
                ref="laudoItemModelo" 
                :id_atendimento="atendimento_procedimento.id_atendimento" 
                :id_procedimento="atendimento_procedimento.id_procedimento" 
                @selecionar="incluir_parte_modelo"/>

        </div>

        <!-- Laudo Normal -->
        <template v-else>
            <div class="d-flex flex-column mb-1" v-if="modelo_revisado">
                <button type="button" class="btn btn-success" @click="aplicar_modelo()">
                    Utilizar o modelo {{ modelo_revisado.st_modelo_prontuario }} (#{{ modelo_revisado.id_modelo_prontuario }})
                </button>
            </div>

            <formulario
                ref="formulario"
                v-if="!refreshing"
                :gutters="true"
                :compact="value.modelo_prontuario ? value.modelo_prontuario.fl_compact : false"
                v-model="value.dados"
                :validate="validate"
                :modeloPadrao="value.id_modelo_prontuario"
                :saved="saved"
                :padrao_procedimento="( atendimento_procedimento.medico_procedimento_unidade ) ? atendimento_procedimento.medico_procedimento_unidade.id_modelo_prontuario : null"
                :id_procedimento="atendimento_procedimento.id_procedimento"
                :id_atendimento="atendimento_procedimento.id_atendimento"
                :id_atendimento_procedimento="atendimento_procedimento.id_atendimento_procedimento"
                :layout_impressao="value.st_layout_impressao"
                :view_with_print="true"
                :id_laudo="value.id_laudo"

                @changeModelo="atualizarModelo"
                @definirModelo="definirModelo"
                @imprimirAnamnese="imprimir(value.id_laudo)"
                :mode="pode_alterar ? 'edit' : 'view'"
                :infopaciente="infopaciente">
                <template v-slot:botoes>
                    <button type="button" class="btn btn-link btn-sm" data-toggle="tooltip" data-placement="top" title="Assinar" 
                        v-if="assinatura && atendimento_procedimento.anamnese"
                        @click="assinar({ ...value, id_anamnese: atendimento_procedimento.anamnese.id_anamnese, model: { type: 'laudo', id: value.id_laudo } })"
                        :disabled="!saved">
                        <i class="fas fa-signature"></i>
                    </button>
                    
                    <button type="button" class="btn btn-link btn-sm" data-toggle="tooltip" data-placement="top" title="Log"
                        @click="$util.logAudit('laudo', value.id_laudo)"
                        v-if="$store.state.user.id_usuario == 1">
                        Log
                    </button>
                </template>
            </formulario>
        </template>

        <template v-if="lista_ordem">
            <!-- Ordenar Partes -->
            <div class="modal fade" id="ordemPartesModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Ordenar</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <ul class="list-group">
                                <draggable v-model="lista_ordem.partes" @start="drag=true" @end="drag=false;" ghost-class="primary">
                                    <li class="list-group-item d-flex justify-content-between" v-for="(parte, ipx) in lista_ordem.partes" :key="ipx">
                                        <div>
                                            {{ titulo_registro(parte) }}
                                            <span class="small text-muted ml-5">{{ parte.in_ordem }}</span>
                                        </div>
                                        <div>
                                            {{ ipx + 1 }}
                                        </div>
                                    </li>
                                </draggable>
                            </ul>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                            <az-submit @click="atualizar_ordem()">Atualizar</az-submit>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import _ from "lodash";
import $ from "jquery";
import * as moment from "moment";
import Formulario from '../consultorio/Formulario.vue';
import LaudoItemModelo from './LaudoItemModelo.vue'
import AzSubmit from '../../util/AzSubmit.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import CamposFormulario from '../consultorio/CamposFormulario.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import draggable from "vuedraggable";

export default {
    data () { 
        return { 
            teste: "", 
            saved: true, 
            timeout: null, 
            hasMounted: true, 
            refreshing: false, 
            lista_ordem: null, 
            drag: false, 
            show_boxes: true, 
            registro_mesclado: null, 
            force_log: false, 
        }
    },

    components: { 
        Formulario,
        LaudoItemModelo, 
        AzSubmit, 
        AzSubTitle, 
        CamposFormulario, 
        AzAuditLogButton, 
        draggable, 
    },

    props: ['value','atendimento_procedimento', 'pode_alterar', 'assinatura', 'atendimento', 'validate', 'textos', 'fila', 'outros_laudos', 'modelo_revisado'],

    computed: {
        infopaciente: function () {
            return {
                id_paciente: _.get(this.atendimento, 'id_paciente'), 
                sexo: _.get(this.atendimento, 'paciente.cadastro.ch_sexo'),
                idade_anos: this.calculateAgeYear(
                    _.get(this.atendimento, 'paciente.cadastro.dt_nascimento'),
                    _.get(this.atendimento, 'dt_inicio')
                ),
                idade_meses: this.calculateAge(
                    _.get(this.atendimento, 'paciente.cadastro.dt_nascimento'),
                    _.get(this.atendimento, 'dt_inicio')
                ),
            };
        },

        is_laudo_partes: function() { 
            if ( !this.value || !this.value.partes ) 
                return false;

            if ( this.value && this.value.partes && this.value.partes.length ) 
                return true;    

            return ( this.atendimento_procedimento 
                && this.atendimento_procedimento.procedimento 
                && this.atendimento_procedimento.procedimento.id_classe_procedimento == 20 ) 
                ? true : false;
        },

        parte_em_edicao: function () { 
            if ( !this.value || !this.value.partes ) 
                return false;

            return this.value.partes.find( parte => parte.fl_ativo && parte.fl_edicao && parte.edicao) ? true : false; 
        },
    },

    watch: {
        value: {
            handler: function(newValue, oldValue) {
                if (!this.hasMounted || !newValue || !oldValue) 
                    return;

                if ( _.get(newValue, 'status_laudo.fl_pronto') ) 
                    return;

                if ( _.get(newValue, 'doc_certificado') ) 
                    return;

                if ( this.$store.state.loading ) 
                    return; 

                this.saved = false;

                if (this.timeout) clearTimeout(this.timeout);

                this.timeout = setTimeout(() => {

                    //console.log('salvar laudo',newValue);

                    let query = {
                        q: [
                            {
                                name: "laudos.salvar",
                                id: "laudo_salvar",
                                parms: { 
                                    ...newValue,
                                    id_fila_laudo: this.fila ? this.fila.id_fila_laudo : null,
                                    force_log: this.force_log,
                                }
                            }
                        ]
                    };

                    this.force_log = false; 

                    this.axios.post("/aql?s=laudos.salvar", query).then(res => {
                        if (
                            res.data.laudo_salvar.status == 200 &&
                            res.data.laudo_salvar.data && 
                            res.data.laudo_salvar.data.status == 'OK' && 
                            res.data.laudo_salvar.data.tratado && 
                            res.data.laudo_salvar.data.dados ) { 

                            this.refreshing = true; 

                            this.$nextTick(() => { 

                                this.value.dados = res.data.laudo_salvar.data.dados;

                                this.saved = true;
                                clearTimeout(this.timeout);

                                this.refreshing = false; 

                            });

                        } else if (
                            res.data.laudo_salvar.status == 200 &&
                            res.data.laudo_salvar.data && 
                            res.data.laudo_salvar.data.status == 'OK' ) { 

                            if ( res.data.laudo_salvar.data.id_laudo_item ) { 
                                this.value.partes.forEach( parte => { 
                                    if ( parte.fl_ativo && parte.edicao && !parte.id_laudo_item ) { 
                                        parte.id_laudo_item = res.data.laudo_salvar.data.id_laudo_item; 
                                    }
                                });
                            }

                            this.saved = true;
                            clearTimeout(this.timeout);    
                            
                        } else if (
                            res.data.laudo_salvar.status == 200 &&
                            res.data.laudo_salvar.data == "OK"
                        ) {
                            this.saved = true;
                            clearTimeout(this.timeout);
                        }
                    });
                    
                }, 1500);
            },

            deep: true,
            immediate: true
        }
    },

    methods: { 
        aplicar_modelo () { 
            this.$refs.formulario.aplicar_modelo(this.modelo_revisado, () => { 
                this.modelo_revisado = null; 
            });
        },

        titulo_agrupado (lista) { 
            return _.groupBy(lista, 'modelo.st_titulo_impressao');
        },

        // Laudo em Partes...

        toggle_compress() { 
            let hide = this.value.partes.find( parte => parte.hide);

            this.value.partes.forEach( parte => { 
                parte.hide = !hide; 
            });

            this.$forceUpdate();
        },

        atualizar_ordem() { 
            this.$util.atualizar(this, { 
                service: 'laudos',
                func: 'atualizar_ordem_partes',
                dados: { 
                    id_laudo: this.value.id_laudo, 
                    partes: this.lista_ordem.partes.map( (parte) => ({ 
                        id_laudo_item: parte.id_laudo_item, 
                    }) ),
                }, 
                callback: () => { 
                    this.value.partes = this.lista_ordem.partes;
                    $('#ordemPartesModal').modal('hide');

                    this.lista_ordem = null; 
                },
                toast: true, 
            });
        },

        ordenar_partes() { 
            this.lista_ordem = _.cloneDeep(this.value); 

            this.$nextTick(() => {
                $('#ordemPartesModal').modal('show');
            });
        },

        pode_editar_laudo () { 
            if ( !this.value ) { 
                return false; 
            }

            if ( this.value.status_laudo && this.value.status_laudo.fl_pronto ) { 
                return false;
            }

            if ( this.value.doc_certificado ) { 
                return false; 
            }

            return true; 
        },


        remover_parte(parte, idx = null) { 

            if ( parte.id_usuario != this.$store.state.user.id_usuario ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Remover",
                    detail: "Somente o responsável pelo registro pode realizar sua remoção.",
                    life: 3000
                });

                return;
            }

            if ( !confirm('Confirmar remoção') )
                return;

            let item = _.cloneDeep(parte);

            item.fl_ativo = false;

            if ( item.id_laudo_item ) { 

                this.$util.atualizar(this, { 
                    service: 'laudo_items',
                    func: 'store',
                    no_validate: true, 
                    dados: item, 
                    callback: () => { 
                        parte.fl_ativo = false;
                    },
                    toast: true, 
                });

            } else if ( idx !== null ) { 

                this.value.partes.splice(idx, 1);

            }
            
        },

        editar_parte(parte) { 
            if ( parte.created_at ) { 
                if ( parte.usuario.medico && ( parte.usuario.medico.id_pessoa != this.$store.state.user.id_pessoa ) ) { 
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Edição não disponível.",
                        life: 3000
                    });

                    return;
                }
            }

            if ( parte.pode_editar === false ) { 

                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Edição não disponível para esse usuário.",
                    life: 3000
                });

                return;

            }

            parte.edicao = true;
            parte.fl_edicao = true; 
        },

        salvar_parte(parte) { 

            if (this.timeout) { 
                clearTimeout(this.timeout);
                this.timeout = null; 
            }

            parte.id_usuario = this.$store.state.user.id_usuario;

            this.validate = false; 

            this.$util.atualizar(this, { 
                service: 'laudo_items',
                func: 'store',
                no_validate: true, 
                dados: parte, 
                callback: res => { 
                    parte.id_laudo_item = res.id_laudo_item;
                    parte.edicao = false; 
                    parte.created_at = res.created_at; 
                    parte.model = { 
                        type: 'laudoItem',
                        id: res.id_laudo_item,
                    };
                    parte.usuario = res.usuario; 

                    if ( res.fl_edicao !== null ) { 
                        parte.fl_edicao = res.fl_edicao; 
                    }
                },
                toast: true, 
            });

        },

        titulo_registro(registro) { 
            return ( registro.modelo ? registro.modelo.search + ': ' : '' ) 
                + _.get(registro, 'usuario.pessoa.st_nome') + ', ' 
                + ( !registro.created_at 
                    ? 'Novo' 
                    : ( this.$util.getFormatDate(registro.created_at) + ' ' + registro.created_at.substr(11,5) ) )
        },

        incluir_mesclado (registro) { 
            this.registro_mesclado = registro;
            this.$refs.laudoItemModelo.abrir();
        },

        mesclar_modelo (modelo) { 

            console.log("MESCLAR MODELO!");

            // Campos Texto...

            let campo_texto = this.registro_mesclado.st_conteudo.find( campo => campo.type == 'rich');

            if ( !campo_texto ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Não foi possível localizar campo de texto para mesclagem.",
                    life: 3000
                });

                return;
            }

            let campo_texto_modelo = modelo.estrutura.find( campo => campo.type == 'rich');

            if ( !campo_texto_modelo ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Não foi possível localizar campo de texto do modelo selecionado.",
                    life: 3000
                });

                return;
            }

            this.force_log = true;

            //

            let texto_index = this.registro_mesclado.st_conteudo.findIndex( campo => campo.type == 'rich');

            if ( texto_index >= 0 ) { 
                if ( !this.registro_mesclado.st_conteudo[texto_index].boxes ) { 
                    this.registro_mesclado.st_conteudo[texto_index].boxes = [];
                }

                this.registro_mesclado.st_conteudo[texto_index].boxes.push({ 
                    i: modelo.id_modelo_prontuario,
                    d: 'D' + this.$util.getFormatDate(new Date(), 'DD HH:mm:ss'), 
                    u: this.$store.state.user.id_usuario, 
                });
            }

            // Campos Grupos...

            let origens = _.keyBy(this.$util.valores(this.registro_mesclado.st_conteudo), 'id');

            let campo_grupo_modelo = modelo.estrutura.find( campo => campo.type == 'group');

            if ( campo_grupo_modelo && campo_grupo_modelo.campos && campo_grupo_modelo.campos.length ) { 

                let intersect = campo_grupo_modelo.campos.find(campo => campo.id && _.get(origens, campo.id));

                if ( intersect ) { 
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Campo conflitante entre os modelos: " + intersect.id,
                        life: 3000
                    });
                } else { 
                    if ( modelo.st_modelo_prontuario ) { 
                        campo_grupo_modelo.label = modelo.st_modelo_prontuario;
                    }

                    this.registro_mesclado.st_conteudo.push(campo_grupo_modelo);
                }
                
            }

            //

            let texto = campo_texto_modelo.value; 

            /*
            if ( campo_texto.value && campo_texto.value.endsWith('<p><br></p>') ) { 
                texto = campo_texto.value.slice(0, -11) + campo_texto_modelo.value;
            } else { 
                texto = campo_texto.value + campo_texto_modelo.value;
            }
            */

            // remover a palavra "undefined" que pode aparecer na mesclagem de forma insensitive
            texto = texto.replace(/undefined/gi, '');

            let formedit = this.$refs['formedit'];

            if ( formedit ) { 
                texto = formedit[0].replace_hashtags(texto, true);

                console.log('quill ativo', formedit[0].quillativo);

                if ( formedit[0].quillativo ) { 
                    console.log('quill texto 2', texto);
                    formedit[0].quillativo.insert_text_on_quill(texto);
                    //this.insert_text_on_quill(formedit[0].quillativo, texto);
                    return; 
                }
            }

            //

            if ( campo_texto.value && campo_texto.value.endsWith('<p><br></p>') ) { 
                texto = campo_texto.value.slice(0, -11) + texto;
            } else { 
                texto = campo_texto.value + texto;
            }

            campo_texto.value = texto;

        },

        insert_text_on_quill(quill, html) { 
            const range = quill.getSelection(true) // true = força foco

            if (!range) return

            // Converte o HTML para Delta e insere na posição do cursor
            quill.clipboard.dangerouslyPasteHTML(range.index, html, 'user')

            // Move o cursor para depois do conteúdo inserido
            const length = quill.getLength()
            quill.setSelection(range.index + quill.getLength() - length, 0)
        },

        incluir_parte_modelo (modelo) { 

            console.log('Incluir Parte Modelo', modelo);

            if ( this.registro_mesclado || !this.value.partes.find(parte => parte.fl_ativo && parte.edicao && parte.id_modelo_prontuario == modelo.id_modelo_prontuario) ) { 

                this.$util.loadItem(this, { 
                    service: 'modelos', 
                    func: 'show', 
                    parms: { id: modelo.id_modelo_prontuario }
                })
                .then( res => {

                    if ( this.registro_mesclado ) { 

                        this.mesclar_modelo (res);
                         
                    } else { 

                        let estrutura = res.estrutura ? _.cloneDeep(res.estrutura) : []; 

                        estrutura = estrutura.map( campo => { 
                            if ( !campo.value ) { 
                                campo.value = ''; 
                            }
                            return campo; 
                        });

                        this.value.partes.push({ 
                            id_laudo_parte: null, 
                            id_laudo: this.value.id_laudo, 
                            id_modelo_prontuario: modelo.id_modelo_prontuario, 
                            created_at: null, 
                            modelo: res,
                            fl_ativo: true,  
                            fl_edicao: true, 
                            st_conteudo: estrutura,
                            st_layout_impressao: res.st_layout_impressao, 
                            id_usuario: this.$store.state.user.id_usuario, 
                            usuario: this.$store.state.user, 
                            edicao: true, 
                            fila_laudo_modelo: res, 
                            novo: true, 
                            in_ordem: 1000, 
                            fl_retificado: false, 
                            hide: false, 
                        });

                    }

                    this.$nextTick(() => {

                        const el = document.querySelector('.em_edicao');

                        if (el) {

                            const editorEl = el.querySelector('.ql-editor');

                            const offset = 100; // pixels extras
                            const y =
                                el.getBoundingClientRect().top +
                                window.pageYOffset -
                                offset;

                            window.scrollTo({
                                top: y,
                                behavior: 'smooth'
                            });

                            if (editorEl) {
                                editorEl.focus();
                            }

                        }
 
                    });
                    
                });  

            }

        },

        incluir_parte() { 
            this.registro_mesclado = null; 

            let teste = this.value.partes.find(parte => parte.fl_ativo && ( parte.fl_edicao || parte.edicao ));

            if ( teste ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Existe um registro em edição. Finalize a edição antes de incluir um novo. (" + teste.id_laudo_item + ")",
                    life: 3000
                });

                return;
            }

            this.$refs.laudoItemModelo.abrir();
        },

        //

        salvado() { 
            if ( this.value ) { 
                if ( this.value.doc_certificado_link || ( this.value.status_laudo && this.value.status_laudo.fl_pronto ) ) { 
                    return true; 
                }
            }

            return this.saved;
        },

        calculateAgeYear (dateString, otherDate) {

            var today = moment(otherDate);
            var birthDate = moment(dateString);
            var age = Math.floor(today.diff(birthDate, 'years', true));
            return age;

        },

        calculateAge (dateString, otherDate) {

            var today = moment(otherDate);
            var birthDate = moment(dateString);
            var age = today.diff(birthDate, 'months', true);
            return age;

            // Código antigo que estava dando diferença de 1 mês no cálculo
            // var today = new Date(otherDate);
            // var birthDate = new Date(dateString);
            // var age = today.getFullYear() - birthDate.getFullYear();
            // var m = today.getMonth() - birthDate.getMonth();
            // age = age * 12 + m;

            // if ( today.getDay() < birthDate.getDay() ) {
            //     age--;
            //     age = age + ( ( birthDate.getDay() - today.getDay() ) / 30 );
            // } else {
            //     age = age + ( ( 30 + birthDate.getDay() - today.getDay() ) / 30 );
            // }

            //return age;
        },

        assinar (order) { 
            this.$emit('assinar', order);
        },

        imprimir(laudo) { 
            this.$util.print_preview('imprimir/laudo/' + laudo, true, { noass: 1, notAssign: 1 }, true);
        },

        atualizarModelo(modelo) {
            this.value.id_modelo_prontuario = modelo.id_modelo_prontuario;
            this.value.st_layout_impressao = modelo.st_layout_impressao;
        },

        definirModelo(id_modelo_prontuario) { 
            console.log('Novo Modelo', id_modelo_prontuario);
            //this.value.id_modelo_prontuario = id_modelo_prontuario;
        },
    }
}
</script>
